import React, { useState, useEffect } from 'react';
import {
  Table,
  TableCell,
  TableHead,
  TableContainer,
  Paper,
  Typography,
  TableBody,
  TableRow,
  IconButton,
  Collapse,
  Box,
  Grid,
  Alert,
  Snackbar,
  CircularProgress,
  Backdrop,
  Stack,
  styled,
  Button,
  ButtonGroup,
  TablePagination,
  DialogContent,
  DialogTitle,
  Dialog
} from '@mui/material';
import XLSX from 'sheetjs-style';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SubCard from 'ui-component/cards/SubCard';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import MandateView from './MandateView';
import FileUpload from './FileUpload';
import { IoMdClose } from 'react-icons/io';
import { MandateAgregatedData, MandateFiles } from 'API/Mandate_Surrender';
import DownloadIcon from '@mui/icons-material/Download';
import { VscEye } from 'react-icons/vsc';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800]
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8'
    })
  }
}));
const Index = () => {
  const [openRows, setOpenRows] = useState({});
  const [selected, setSelected] = useState('OPEN');
  const [Viewopen, setViewopen] = useState(false);
  const [open, setOpen] = useState(false);
  const [Success, setSuccess] = useState([]);
  const [MandateData, setMandateData] = useState([]);
  const [Error, setError] = useState(false);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [TotalCount, setTotalCount] = useState('');
  const [BankName, setBankName] = useState('');
  const [DisableValue, setDisableValue] = useState('false');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    // setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };

  const handleView = (bank, type) => {
    setMandateType(type);
    setBankName(bank);
    setViewopen(true);
  };
  const [rowsPerPageTable, setRowsPerPageTable] = useState(10);
  const [pageTable, setPageTable] = useState(0);
  const [MandateType, setMandateType] = useState('');

  const handleChangePageTable = (event, newPage) => {
    setPageTable(newPage);
  };

  const handleChangeRowsPerPageTable = (event) => {
    setRowsPerPageTable(+event.target.value);
    setPageTable(0);
  };

  const handleToggleRow = (index, bank, type, value) => {
    setDisableValue(value);
    setBankName(bank);
    setMandateType(type);
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [index]: !prevOpenRows[index]
    }));
  };
  const refuntion = () => {
    // MandateFiles(page, rowsPerPage,setIsloading, setSuccess, setError, setTotalCount);
    setMandateData([]);
    MandateAgregatedData(selected, setIsloading, setMandateData, setError);
    // setSuccess([]);
    // MandateFiles(page + 1, rowsPerPage, setIsloading, setSuccess, setError, setTotalCount, BankName, MandateType);
  };
  useEffect(() => {
    if (BankName) {
      setSuccess([]);
      // setSelected('')
      MandateFiles(page + 1, rowsPerPage, setIsloading, setSuccess, setError, setTotalCount, BankName, MandateType);
    }
  }, [page, rowsPerPage, BankName, MandateType]);

  useEffect(() => {
    setMandateData([]);
    MandateAgregatedData(selected, setIsloading, setMandateData, setError);
  }, [selected]);

  const downloadExcel = () => {
    // Transform the keys of PaymentData for the header
    const formatHeader = (key) =>
      key
        .split('_') // Split the key by underscores
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(' '); // Join the words with spaces

    if (MandateData.length > 0) {
      // Extract the header keys and transform them
      const transformedHeaders = Object.keys(MandateData[0]).map((key) => formatHeader(key));

      // Convert JSON data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(MandateData);

      // Rename the headers in the worksheet
      const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
      for (let col = 0; col <= headerRange.e.c; col++) {
        const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
        worksheet[headerCell].v = transformedHeaders[col];
      }

      // Set column widths
      const columnWidths = Object.keys(MandateData[0]).map((key) => {
        // Calculate column width based on the header and data length
        const maxLength = Math.max(
          key.length, // Length of the header
          ...MandateData.map((row) => (row[key] ? row[key].toString().length : 0)) // Maximum length of the data in the column
        );
        return { wch: maxLength + 5 }; // Add padding for readability
      });
      worksheet['!cols'] = columnWidths;

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Write the Excel file and trigger a download
      const fileName = `MandateReport.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } else {
      alert('No data available to export!');
    }
  };

  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Grid item xl={12} width="100%">
        {/* <MainCard >

    </MainCard> */}
        <SubCard
          title="Mandate"
          sx={{
            // marginTop: '20px',
            width: '100%',
            overflow: 'scroll',
            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px'
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '8px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555'
            }
          }}
        >
          {!Viewopen ? (
            <>
              <Grid container justifyContent="space-between" spacing={1} sx={{ mb: 1 }}>
                <Grid item>
                  <ButtonGroup variant="outlined" aria-label="Loading button group">
                    {['OPEN', 'FIXED'].map((status) => (
                      <Button
                        key={status}
                        onClick={() => {
                          setSelected(status);
                          setOpenRows({});
                          setDisableValue('false');
                        }}
                        size="medium"
                        color="secondary"
                        sx={{
                          backgroundColor: selected === status ? '#592375' : '#fff',
                          '&:hover': {
                            backgroundColor: selected === status ? '#592375' : ''
                          }
                        }}
                        variant={selected === status ? 'contained' : 'outlined'}
                      >
                        {status}
                      </Button>
                    ))}
                  </ButtonGroup>
                </Grid>
                <Grid item>
                  <Button
                    size="medium"
                    color="secondary"
                    sx={{
                      backgroundColor: '#688B2A',
                      color: '#FFFFFF',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#688B2A'
                      }
                    }}
                    variant="contained"
                    onClick={() => setOpen(true)}
                    endIcon={<UploadFileOutlinedIcon />}
                  >
                    upload mandate
                  </Button>
                </Grid>
              </Grid>
              <Paper sx={{ width: '90%' }}>
                <TableContainer
                  sx={{
                    maxHeight: 1000,
                    width: 1190,
                    '&::-webkit-scrollbar': {
                      width: '8px',
                      height: '8px'
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1'
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#888',
                      borderRadius: '8px'
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555'
                    }
                  }}
                >
                  {MandateData && MandateData.length ? (
                    <Table stickyHeader aria-label="sticky table" size="small">
                      <TableHead>
                        <TableRow>
                          {/* <TableCell sx={{ width: '10%' }} /> */}
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Bank Name</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Progress</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>No of Mandate</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Pending</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>In Progress</TableCell>
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Completed</TableCell>
                          {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%', color: '#592375' }}>Mandate expiry date</TableCell>} */}
                          <TableCell sx={{ width: '10%', color: '#592375' }}>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {MandateData &&
                          MandateData.map((row, index) => (
                            <React.Fragment key={index}>
                              <TableRow hover role="checkbox" tabIndex={-1} sx={{ cursor: 'pointer' }}>
                                {/* <TableCell sx={{ width: '10%' }}>
                        <IconButton aria-label="expand row" size="small" onClick={() => handleToggleRow(1)}>
                          {openRows[1] ? < KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell> */}
                                <TableCell sx={{ width: '10%' }}>
                                  {row.bank_name}{' '}
                                  {DisableValue === 'false' ? (
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={() => handleToggleRow(index, row.bank_name, selected, 'true')}
                                    >
                                      {openRows[index] ? (
                                        <DriveFolderUploadOutlinedIcon color="info" />
                                      ) : (
                                        <DriveFileMoveOutlinedIcon color="info" />
                                      )}
                                    </IconButton>
                                  ) : (
                                    ''
                                  )}
                                </TableCell>
                                <TableCell sx={{ width: '10%' }}>
                                  <BorderLinearProgress variant="determinate" value={(row.total_completed / row.total_bcs_vacancy) * 100} />
                                  <span style={{ display: 'flex', justifyContent: 'center' }}>
                                    {((row.total_completed / row.total_bcs_vacancy) * 100).toFixed(4)}%
                                  </span>
                                </TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_bcs_vacancy}</TableCell>
                                <TableCell sx={{ width: '10%' }}>
                                  {row.total_bcs_vacancy - row.total_completed - row.total_in_progress - row.total_surrendered}
                                </TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_in_progress}</TableCell>
                                <TableCell sx={{ width: '10%' }}>{row.total_completed}</TableCell>
                                {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%' }}>Agent</TableCell>} */}
                                <TableCell sx={{ width: '10%' }}>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => handleView(row.bank_name, selected)}
                                    endIcon={<VscEye />}
                                  >
                                    view
                                  </Button>
                                </TableCell>
                              </TableRow>

                              {/* Collapsible Row for Installments */}
                              <TableRow>
                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                                  <Collapse in={openRows[index]} timeout="auto" unmountOnExit>
                                    <Box sx={{ margin: 1 }}>
                                      <Typography variant="h4" gutterBottom component="div" mt={2}>
                                        Mandate Details
                                      </Typography>
                                      {Success && Success.length ? (
                                        <Table size="small" aria-label="installments">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>Mandate ID</TableCell>
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>Mandate Category</TableCell>
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>No of Mandate</TableCell>
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>Pending</TableCell>
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>In Progress</TableCell>
                                              {selected === 'FIXED' && (
                                                <TableCell sx={{ width: '10%', color: '#592375' }}>Expiry date</TableCell>
                                              )}
                                              {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%', color: '#592375' }}>Penality</TableCell>} */}
                                              {/* {selected === 'Open'&&<TableCell sx={{ width: '10%', color: '#592375' }}>Sourced</TableCell>} */}
                                              <TableCell sx={{ width: '10%', color: '#592375' }}>Completed</TableCell>
                                              {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%', color: '#592375' }}>Expired</TableCell>} */}
                                              {selected === 'FIXED' && (
                                                <TableCell sx={{ width: '10%', color: '#592375' }}>Surrender</TableCell>
                                              )}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {Success &&
                                              Success.map((row, index) => (
                                                <TableRow key={index}>
                                                  <TableCell sx={{ width: '10%' }}>{row.mandate_id}</TableCell>
                                                  <TableCell sx={{ width: '10%' }}>{row.mandate_type}</TableCell>
                                                  <TableCell sx={{ width: '10%' }}>{row.total_bcs_vacancy}</TableCell>
                                                  <TableCell sx={{ width: '10%' }}>
                                                    {row.total_bcs_vacancy -
                                                      row.total_completed -
                                                      row.total_in_progress -
                                                      row.total_surrendered}
                                                  </TableCell>
                                                  <TableCell sx={{ width: '10%' }}>{row.total_in_progress}</TableCell>
                                                  {selected === 'FIXED' && (
                                                    <TableCell sx={{ width: '10%' }}>{row.expiry_date || '-'}</TableCell>
                                                  )}
                                                  {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%' }}>Demo</TableCell>} */}
                                                  {/* {selected === 'Open' && <TableCell sx={{ width: '10%' }}>Demo</TableCell>} */}
                                                  <TableCell sx={{ width: '10%' }}>{row.total_completed}</TableCell>
                                                  {/* {selected === 'FIXED' && <TableCell sx={{ width: '10%' }}>Demo</TableCell>} */}
                                                  {selected === 'FIXED' && (
                                                    <TableCell sx={{ width: '10%' }}>{row.total_surrendered}</TableCell>
                                                  )}
                                                </TableRow>
                                              ))}
                                          </TableBody>
                                        </Table>
                                      ) : (
                                        <Stack justifyContent="center" alignItems="center">
                                          <Typography mt={5} mb={3} variant="h5">
                                            No Mandate data found
                                          </Typography>
                                        </Stack>
                                      )}
                                    </Box>
                                    <Grid container alignItems="flex-start" justifyContent="space-between">
                                      <Grid item>
                                        <Button
                                          size="small"
                                          sx={{ display: 'flex', justifyContent: 'end' }}
                                          onClick={() => handleToggleRow(index, row.bank_name, selected, 'false')}
                                          endIcon={<KeyboardArrowUpIcon />}
                                        >
                                          Show less
                                        </Button>
                                      </Grid>
                                      <Grid item>
                                        <TablePagination
                                          // sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'flex-start',
                                            mt: -3
                                          }}
                                          rowsPerPageOptions={[10, 25, 100]}
                                          component="div"
                                          count={TotalCount}
                                          rowsPerPage={rowsPerPage}
                                          page={page}
                                          onPageChange={handleChangePage}
                                          onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <Stack justifyContent="center" alignItems="center">
                      <Typography mt={5} mb={3} variant="h5">
                        No data found
                      </Typography>
                    </Stack>
                  )}
                </TableContainer>
                {/* Pagination */}
                {MandateData && MandateData.length > 0 ? (
                  <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                      {/* <PaymentReport UserData={Datatable} /> */}
                      <Button variant="outlined" size="small" color="secondary" startIcon={<DownloadIcon />} onClick={downloadExcel}>
                        Export to Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <TablePagination
                        sx={{ width: '100%' }}
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={MandateData && MandateData.length}
                        rowsPerPage={rowsPerPageTable}
                        page={pageTable}
                        onPageChange={handleChangePageTable}
                        onRowsPerPageChange={handleChangeRowsPerPageTable}
                      />
                    </Grid>
                  </Grid>
                ) : null}
              </Paper>
            </>
          ) : (
            <MandateView
              setViewopen={setViewopen}
              Success={Success}
              TotalCount={TotalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </SubCard>
      </Grid>
      {/* dialog */}
      <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="sm" fullWidth>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4">File Upload</Typography>
        </DialogTitle>
        <IconButton sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', fontSize: '22px' }} onClick={() => setOpen(false)}>
          <IoMdClose />
        </IconButton>
        <DialogContent sx={{ margin: 0, paddingBlock: 0 }} dividers>
          <FileUpload setOpen={setOpen} refuntion={refuntion} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Index;
